var _style, _g, _rect, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMindLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 396.6 182",
    style: {
      enableBackground: "new 0 0 396.6 182"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_00000169530882982994379040000016157791321556959656_);}\n\t.st3{fill:url(#SVGID_00000160900007403809254800000015840962607951294385_);}\n\t.st4{fill:#F9CE6E;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M188.3,78.8c0-3.2-2.6-5.7-5.7-5.7c-3.2,0-5.7,2.5-5.7,5.7v27.9h-15.6V58.3h12v2.2c3.1-1.8,6.7-3,10.4-3 c4.9,0,8.8,1.9,12.5,4.8c3.7-2.9,8.5-4.8,13.7-4.8c11.7,0,21.4,9.6,21.4,21.3v27.9h-15.7V78.8c0-3.2-2.6-5.7-5.8-5.7 c-3.1,0-5.7,2.5-5.7,5.7v27.9h-15.7V78.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M260.6,43.6c0,5.3-3.6,8.9-9,8.9c-4.6,0-8.8-3.6-8.8-8.9c0-4.6,4.3-8.7,8.8-8.7 C257,34.9,260.6,39.1,260.6,43.6z M259.3,106.7h-15.2V58.3h15.2V106.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M315.3,78.8v27.9h-15.6V78.8c0-3.2-2.5-5.7-5.7-5.7c-3.2,0-5.8,2.5-5.8,5.7v27.9h-15.5V58.3h12v2.2 c3.3-1.9,6.8-3,10.5-3C306.5,57.5,315.3,67.1,315.3,78.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M360.7,59.3V38.9h15.6v67.8h-12.9v-2.2c-3.6,1.9-7.8,3-12,3c-13.8,0-25-11.2-25-25s11.2-25,25-25 C354.6,57.5,357.9,58.1,360.7,59.3z M360.9,82.5c0-5-4.3-9.2-9.2-9.2c-4.9,0-9.2,4.2-9.2,9.2c0,4.9,4.3,9.2,9.2,9.2 C356.7,91.7,360.9,87.4,360.9,82.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 4.8696,
    y1: 142.78,
    x2: 99.2489,
    y2: 35.3483
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#47EFF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#297BFF"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.3,
    y: 64,
    className: "st1",
    width: 19.9,
    height: 97.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000027578801838074075770000016949096644938754455_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.7796,
    y1: 159.3925,
    x2: 118.1588,
    y2: 51.9608
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#47EFF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#297BFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000027578801838074075770000016949096644938754455_)"
    },
    d: "M72.3,64H64v75.2h21.1V76.8 C85.1,69.7,79.4,64,72.3,64z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000180327186215012862250000004015826636627082414_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.5017,
    y1: 156.5129,
    x2: 114.881,
    y2: 49.0812
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#47EFF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#297BFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000180327186215012862250000004015826636627082414_)"
    },
    d: "M73.6,20.6H64v19.9h9.6 c19.3,0,35.1,15.7,35.1,35.1v44.3h19.9V75.6C128.6,45.3,103.9,20.6,73.6,20.6z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M156.8,131.1v8.6h-2.6v-0.9h0c-0.6,0.7-1.4,1.1-2.4,1.1c-2.4,0-4.1-1.8-4.1-4.5c0-2.6,1.7-4.5,3.9-4.5 c0.9,0,1.8,0.4,2.4,1.1h0v-0.9H156.8z M154.2,135.5c0-1.2-0.8-2-1.8-2c-1.1,0-1.9,0.8-1.9,2c0,1.2,0.8,2,1.8,2 C153.4,137.5,154.2,136.7,154.2,135.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M167.9,134.6v5.2h-2.8v-4.5c0-1.4-0.5-1.8-1.4-1.8c-0.9,0-1.6,0.7-1.6,2v4.3h-2.8v-8.6h2.8v1h0 c0.7-0.8,1.6-1.2,2.6-1.2C166.6,131,167.9,131.9,167.9,134.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M175.3,135.5c0-2.6,1.9-4.5,4.7-4.5c2.7,0,4.6,1.8,4.6,4.5c0,2.6-1.9,4.5-4.6,4.5 C177.2,139.9,175.3,138.1,175.3,135.5z M181.8,135.5c0-1.2-0.8-2-1.9-2c-1.1,0-1.9,0.9-1.9,2c0,1.2,0.8,2,1.9,2 C181,137.5,181.8,136.6,181.8,135.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M196.1,135.5c0,2.7-1.7,4.5-4.1,4.5c-1,0-1.8-0.4-2.3-1h0v4.3h-2.8v-12.1h2.8v0.9h0c0.6-0.7,1.5-1.1,2.5-1.1 C194.4,131,196.1,132.8,196.1,135.5z M193.3,135.5c0-1.2-0.8-2-1.9-2c-1.1,0-1.9,0.9-1.9,2c0,1.2,0.8,2,1.9,2 C192.5,137.5,193.3,136.7,193.3,135.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M206.5,136.2h-5.9c0.2,1,1.1,1.5,2,1.5c0.8,0,1.5-0.4,2.1-1l1.5,1.6c-0.7,0.9-2.1,1.6-3.8,1.6 c-2.6,0-4.5-1.8-4.5-4.5c0-2.6,1.8-4.5,4.4-4.5c2.5,0,4.3,1.8,4.3,4.4C206.6,135.6,206.5,136,206.5,136.2z M200.7,134.6l3.2,0 c-0.2-0.8-0.7-1.4-1.6-1.4C201.5,133.2,200.8,133.7,200.7,134.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M217.3,134.6v5.2h-2.8v-4.5c0-1.4-0.5-1.8-1.4-1.8c-0.9,0-1.6,0.7-1.6,2v4.3h-2.8v-8.6h2.8v1h0 c0.7-0.8,1.6-1.2,2.6-1.2C216,131,217.3,131.9,217.3,134.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M224.4,138.7l1.3-1.9c0.7,0.7,1.5,1,2.3,1c0.5,0,0.8-0.2,0.8-0.5c0-0.2-0.3-0.4-1.3-0.7 c-1.4-0.4-2.7-1.2-2.7-2.9c0-1.7,1.4-2.7,3.2-2.7c1.3,0,2.2,0.4,3.2,1.1l-1.3,2c-0.6-0.6-1.4-0.9-1.9-0.9c-0.2,0-0.6,0.1-0.6,0.4 c0,0.2,0.3,0.4,1.1,0.7c1.9,0.7,2.9,1.1,2.9,2.8c0,1.6-1.1,2.8-3.5,2.8C226.6,139.9,225.4,139.5,224.4,138.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M233.2,135.5c0-2.6,1.9-4.5,4.7-4.5c2.7,0,4.6,1.8,4.6,4.5c0,2.6-1.9,4.5-4.6,4.5 C235.1,139.9,233.2,138.1,233.2,135.5z M239.7,135.5c0-1.2-0.8-2-1.9-2c-1.1,0-1.9,0.9-1.9,2c0,1.2,0.8,2,1.9,2 C238.9,137.5,239.7,136.6,239.7,135.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M253,131.1v8.6h-2.8v-1h0c-0.6,0.8-1.5,1.1-2.4,1.1c-1.8,0-3.1-0.9-3.1-3.7v-5.1h2.8v4.4 c0,1.4,0.4,1.9,1.3,1.9c0.8,0,1.5-0.7,1.5-2.1v-4.3H253z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M261,131v3c-0.2,0-0.5,0-0.6,0c-1.3,0-2,0.8-2,2v3.9h-2.8v-8.6h2.8v1.2h0C259,131.4,259.9,131,261,131 C260.9,131,261,131,261,131z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M266.8,139.9c-2.6,0-4.5-1.8-4.5-4.5c0-2.7,1.9-4.5,4.6-4.5c1.4,0,2.9,0.6,3.7,1.7l-1.8,1.6 c-0.4-0.5-1-0.8-1.8-0.8c-1.2,0-1.9,0.8-1.9,2c0,1.2,0.8,2,2,2c0.9,0,1.4-0.4,1.8-0.8l1.9,1.6C270,139.2,268.7,139.9,266.8,139.9 L266.8,139.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M281,136.2h-5.9c0.2,1,1.1,1.5,2,1.5c0.8,0,1.5-0.4,2.1-1l1.5,1.6c-0.7,0.9-2.1,1.6-3.8,1.6 c-2.6,0-4.5-1.8-4.5-4.5c0-2.6,1.8-4.5,4.4-4.5c2.5,0,4.3,1.8,4.3,4.4C281,135.6,281,136,281,136.2z M275.1,134.6l3.2,0 c-0.2-0.8-0.7-1.4-1.6-1.4S275.3,133.7,275.1,134.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M288.1,135.5c0-2.6,1.9-4.5,4.7-4.5c2.7,0,4.6,1.8,4.6,4.5c0,2.6-1.9,4.5-4.6,4.5 C289.9,139.9,288.1,138.1,288.1,135.5z M294.6,135.5c0-1.2-0.8-2-1.9-2c-1.1,0-1.9,0.9-1.9,2c0,1.2,0.8,2,1.9,2 C293.8,137.5,294.6,136.6,294.6,135.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M299.9,133.4H299v-2.2h0.8v-1.3c0-2.1,1.1-3.2,2.8-3.2c1.1,0,2,0.4,2.3,0.7l-0.5,2c-0.4-0.2-0.8-0.3-1.1-0.3 c-0.5,0-0.8,0.2-0.8,0.9v1.2h1.6v2.2h-1.6v6.4h-2.8V133.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M324,131.1l-2.9,8.6h-2.3l-1.3-4.8h0l-1.3,4.8h-2.3l-2.9-8.6h2.7l1.4,4.6h0l1.3-4.6h2.2l1.3,4.6h0l1.4-4.6H324 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M325.7,128.5c0-0.9,0.8-1.6,1.7-1.6c1,0,1.7,0.7,1.7,1.6c0,1-0.8,1.6-1.7,1.6 C326.5,130.1,325.7,129.5,325.7,128.5z M326.1,131.1h2.7v8.6h-2.7V131.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M330.9,138.7l1.3-1.9c0.7,0.7,1.5,1,2.3,1c0.5,0,0.8-0.2,0.8-0.5c0-0.2-0.3-0.4-1.3-0.7 c-1.4-0.4-2.7-1.2-2.7-2.9c0-1.7,1.4-2.7,3.2-2.7c1.3,0,2.2,0.4,3.2,1.1l-1.3,2c-0.6-0.6-1.4-0.9-1.9-0.9c-0.2,0-0.6,0.1-0.6,0.4 c0,0.2,0.3,0.4,1.1,0.7c1.9,0.7,2.9,1.1,2.9,2.8c0,1.6-1.1,2.8-3.5,2.8C333.1,139.9,331.9,139.5,330.9,138.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M348.8,126.8v13h-2.6v-0.9h0c-0.6,0.7-1.4,1.1-2.5,1.1c-2.4,0-4.1-1.8-4.1-4.5c0-2.6,1.7-4.5,3.9-4.5 c1,0,1.8,0.4,2.4,1.1h0v-5.3H348.8z M346.1,135.5c0-1.2-0.8-2-1.9-2c-1,0-1.8,0.8-1.8,2c0,1.2,0.8,2,1.8,2 C345.3,137.5,346.1,136.7,346.1,135.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M351.1,135.5c0-2.6,1.9-4.5,4.7-4.5c2.7,0,4.6,1.8,4.6,4.5c0,2.6-1.9,4.5-4.6,4.5 C353,139.9,351.1,138.1,351.1,135.5z M357.6,135.5c0-1.2-0.8-2-1.9-2c-1.1,0-1.9,0.9-1.9,2c0,1.2,0.8,2,1.9,2 C356.8,137.5,357.6,136.6,357.6,135.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M373.3,131c1.8,0,3.1,1,3.1,3.8v5h-2.7v-4.4c0-1.1-0.3-1.9-1.3-1.9c-0.8,0-1.4,0.7-1.4,2v4.3h-2.7v-4.4 c0-1.1-0.3-1.9-1.3-1.9c-0.9,0-1.5,0.7-1.5,2v4.3h-2.8v-8.6h2.8v1h0c0.7-0.7,1.5-1.1,2.4-1.1c1.1,0,1.9,0.4,2.5,1.2h0 C371.1,131.4,372.1,131,373.3,131L373.3,131z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMindLogo);
export default __webpack_public_path__ + "static/media/mind_logo.344ca2ed4cb455880637a910a8233589.svg";
export { ForwardRef as ReactComponent };